<template>
<div>
  Stress Testing with multiple games running in parallel...
</div>
</template>

<script>
export default {
  name: 'stress-test',
  created() {
//    this.oneMatch();
    this.bigStressWithTimer();
//    this.bigStressWithoutTimer();
  },
  methods: {
    oneMatch() {
      /* eslint-disable */
      window.open("https://localhost:9090/#/testGameFlow/97369900002", '_blank');
      window.open("https://localhost:9090/#/testGameFlow/97369900093", '_blank');
    },
    bigStressWithTimer() {
      let i = 2;
      let msisdn = '97369900002';
      console.log('sending player answer');
      const timer = setInterval(() => {
        i++;
        window.open(`https://localhost:47887/#/testGameFlow/${msisdn.substring(0, msisdn.length - i.toString().length).concat(i.toString())}`, '_blank');
        if (i === 55) {
          clearInterval(timer);
        }
      }, 15000);
    },
    bigStressWithoutTimer() {
      let i;
      let msisdn = '97369900002';
      for (i = 1; i <= 100; i++) {
        console.log('sending player answer');
        //window.open(`http://10.20.68.80:8181/?#/testGameFlow/${msisdn.concat(i.toString())}`, '_blank');
        window.open(`https://localhost:9090/#/testGameFlow/${msisdn.substring(0, msisdn.length - i.toString().length).concat(i.toString())}`, '_blank');
      }
    }
  },
};
</script>



// WEBPACK FOOTER //
// src/components/stressTests/StressTest.vue